import { createSelector, Selector } from "reselect";
import { RootState } from "../../types";
import cloneDeep from "lodash.clonedeep";

export const countrySelector: Selector<RootState, RootState["country"]> = (state) => state.country;

export const countryListSelector = createSelector(countrySelector, (country) => cloneDeep(country.countryList));

export const regionsSelector = createSelector(countrySelector, (country) => ({
  USA: cloneDeep(country.usaRegions),
  IND: cloneDeep(country.indiaRegions),
  AUS: cloneDeep(country.australiaRegions)
}));
